import { Traveler } from '@flysas-tech/book-value-stream-models';
import { Object, Omit, Static } from '@sinclair/typebox';

export type PartnerAwardSavedTraveler = Static<typeof PartnerAwardSavedTraveler>;
export const PartnerAwardSavedTraveler = Object({
  ...Omit(Traveler, ['type', 'isPrimary']).properties,
});

export type PartnerAwardTemporaryTraveler = Omit<Traveler, 'id' | 'isPrimary'>;
